export enum ERegistrantsUrls {
  HOST_APP = 'host-app',
  WORKSHOPS = 'workshops',
  EVENTS = 'events',
  REGISTRANTS = 'registrants',
  SESSIONS = 'sessions',
  ATTENDANCE = 'attendance',
  CHILDCARE = 'childcare',
}
